<template>
  <v-col
    cols="12"
    md="6"
    lg="3"
  >
    <v-card
      :color="getColor"
      dark
    >
      <v-card-subtitle>{{ title }}</v-card-subtitle>

      <v-card-title class="text-h5">
        <span>{{ content }}</span>
      </v-card-title>


    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "HeaderBlock",
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    color: {
      type: String
    }
  },
  computed: {
    getColor() {
      if (this.color) {
        return this.color;
      }

      return "#5d3791";
    }
  }
}
</script>

<style lang="scss" scoped>

.v-card__subtitle {
  padding-bottom: 0px;
  text-transform: uppercase;
  color: rgba(255,255,255,0.8);
}
.v-card__title {
  padding-top: 5px;
  font-size: 1.6rem !important;

  &.smaller {
    font-size: 1.4rem !important;
  }
}


</style>
